import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Textarea/Textarea.docs.json';
import { Textarea } from '@primer/react';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Box = makeShortcode("Box");
const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <DeprecationBanner replacementUrl={'/design/components/textarea/react'} mdxType="DeprecationBanner" />
    <Box sx={{
      border: '1px solid',
      borderColor: 'border.default',
      borderRadius: 2,
      padding: 6,
      marginBottom: 3
    }} mdxType="Box">
  <Textarea mdxType="Textarea" />
    </Box>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Textarea} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <Note variant="warning" mdxType="Note">
      <p>{`Textarea components `}<strong parentName="p">{`must always`}</strong>{` be accompanied by a corresponding label to improve support for assistive
technologies. Examples below are provided for conciseness and may not reflect accessibility best practices.`}</p>
      <p>{`Use the `}<a parentName="p" {...{
          "href": "/FormControl"
        }}>{`FormControl`}</a>{` component to render a Textarea with a corresponding label.`}</p>
    </Note>
    <h3>{`Controlled mode`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const TextareaExample = () => {
  // Running in controlled mode (recommended)
  const [value, setValue] = React.useState('')

  const handleChange = event => {
    setValue(event.target.value)
  }

  return <Textarea placeholder="Enter a description" onChange={handleChange} value={value} />
}

render(<TextareaExample />)
`}</code></pre>
    <h3>{`Uncontrolled mode`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const TextareaExample = () => {
  const ref = React.useRef()

  const handleSubmit = event => {
    event.preventDefault()
    if (!ref.current.value) {
      alert(\`Enter a value into the Textarea and press submit\`)
      return
    }

    alert(\`Current Textarea value: \${ref.current.value}\`)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Textarea
        cols={40}
        rows={8}
        ref={ref}
        defaultValue="Set the initial state in uncontrolled mode using the defaultValue prop"
      />
      <br />
      <Button type="submit">Submit</Button>
    </form>
  )
}

render(<TextareaExample />)
`}</code></pre>
    <h3>{`Displaying form validation state`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Box as="label" htmlFor="success-state" sx={{display: 'block'}}>
    Success state:
  </Box>
  <Textarea id="success-state" validationStatus="success" />
  <Box as="label" htmlFor="error-state" sx={{display: 'block', mt: 5}}>
    Error state:
  </Box>
  <Textarea id="error-state" validationStatus="error" />
</>
`}</code></pre>
    <h3>{`Inactive`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Textarea disabled>This text is inactive</Textarea>
</>
`}</code></pre>
    <h3>{`Resize`}</h3>
    <p>{`By default, `}<inlineCode parentName="p">{`Textarea`}</inlineCode>{` can be resized by the user vertically and horizontally. Resizing can be prevented by setting `}<inlineCode parentName="p">{`resize`}</inlineCode>{` to `}<inlineCode parentName="p">{`none`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Textarea cols={40} resize="none" />
`}</code></pre>
    <h3>{`Custom styling`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Textarea sx={{marginBottom: 2}} />
  <p>Custom styles like \`margin\` and \`padding\` can be applied using the \`sx\` prop</p>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      